<script>
import { getSupplierDigitalAnalyticsReportStats } from '@/graphql/analytics/digital/supplierDigitalAnalyticsQueries.graphql';
import { QueryMixin } from '@/components/Core/Helpers';

export default {
  mixins: [QueryMixin],
  props: {
    type: {
      type: String,
      required: true
    },
    filter: {
      type: Object,
      default: null
    }
  },
  query() {
    return {
      query: getSupplierDigitalAnalyticsReportStats,
      variables: {
        supplier_id: this.$store.getters['auth/supplierId'],
        type: this.type,
        filter: this.filter
      }
    };
  }
};
</script>
